import { useEffect, useMemo, useState } from "react";

import { Flow, FlowVersion } from "src/api/flowTypes";
import { Button } from "src/design-system/Button";
import { Modal } from "src/design-system/Modal";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { SelectFlowAndVersion } from "src/SelectFlowPane/SelectFlowPane";

export const FlowSelectionModal: React.FC<{
  open: boolean;
  handleClose: () => void;
  handleSubmit: (version: FlowVersion, flow: Flow) => void;
}> = ({ open, handleClose, handleSubmit }) => {
  const { flow: currentFlow } = useAuthoringContext();
  const [selectedFlow, setSelectedFlow] = useState<Flow | null>(null);
  const [selectedVersion, setSelectedVersion] = useState<FlowVersion | null>(
    null,
  );

  const excludeFlowIds = useMemo(() => [currentFlow.id], [currentFlow.id]);

  // Reset the modal state upon reopening
  useEffect(() => {
    if (open) {
      setSelectedFlow(null);
      setSelectedVersion(null);
    }
  }, [open]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Modal.Header>Select a Decision Flow and version</Modal.Header>
      <Modal.Content>
        <div className="flex h-[540px] flex-col">
          <SelectFlowAndVersion
            disableFlowsWithChildFlows={true}
            excludeArchivedVersions={false}
            excludeFlowIds={excludeFlowIds}
            selectedFlow={selectedFlow}
            selectedVersionId={selectedVersion?.id}
            onFlowSelect={setSelectedFlow}
            onVersionSelect={setSelectedVersion}
          />
        </div>
      </Modal.Content>
      <Modal.Footer
        primaryButton={
          <Button
            dataLoc="flow-selection-submit"
            isDisabled={selectedFlow === null || selectedVersion === null}
            onClick={() => {
              if (selectedVersion && selectedFlow) {
                handleSubmit(selectedVersion, selectedFlow);
                handleClose();
              }
            }}
          >
            Select a Decision Flow and version
          </Button>
        }
      ></Modal.Footer>
    </Modal>
  );
};
